/* Start native controls after their markup exists, independently of deferred app scripts. */
(() => {
  const entry = document.currentScript;
  const sources = ['delivery', 'discovery', 'storefront'].map(key => entry.dataset[key]);
  async function start() {
    for (const src of sources) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    }
  }
  // Native variant select remains available if an asset cannot load.
  start().catch(() => {});
})();
